import React from 'react';
import Error401 from '../pages/error/page401';
import MainLayoult from './main';
import Security from '../services/seguridad';
import Common from '../services/common';

interface IProps {
  children?: any;
}

interface IState {
}

class Index extends React.Component<IProps, IState> {

  componentDidMount(): void {

    ///GGR - acá se debe importar el thema que se está usando
    //    Common.session.set("THEME", "dark")
    //if (Common.session.get("THEME") === 'dark') require('../assets/styles/dark.theme.module.scss'); else require('../assets/styles/base.module.scss');
    require('../assets/styles/base.module.scss')
    //require('../assets/styles/dark.theme.module.scss');
  }

  render() {
    const { children } = this.props;

    const logueado = !!Security.User;
    const requiereLogueo = !window.location.pathname.match(/^\/(login|recoverypass)(|\?.*|\/.*)$/i)

    // usuario NO logueado accediendo a pagina sin autorización (OK - sin layoult)
    if (window.location.pathname === '/borrar-cache')
      return (<>{children}</>);


    // usuario NO logueado intentando de entrar a una pagina privada (X)
    if (!logueado && requiereLogueo) {
      Common.url.redirect('/login', { r: Common.url.url() });
      return (<></>);
    }

    // usuario logueado intentando acceder a pagina de usuarios sin autorización (X)
    if (logueado && !requiereLogueo) {
      Common.url.redirect(Common.url.query().r ?? '/');
      return (<></>); ///TODO - GGR: poner un loader ?
    }

    // usuario NO logueado accediendo a pagina sin autorización (OK - sin layoult)
    if (!logueado && !requiereLogueo)
      return (<>{children}</>);


    // usuario logueado accediendo a página con autorización (OK)
    const menu = Security.GetMenuArray(true).find(p => p.url === window.location.pathname);
    if (!Security.HasPermiso(menu?.access)) {
      return (
        <MainLayoult>
          <Error401 />
        </MainLayoult>
      );
    }

    return (
      <MainLayoult>
        {children}
      </MainLayoult>
    );
  }
}

export default Index;
